import React from "react";
import { ElementsConsumer, PaymentElement } from "@stripe/react-stripe-js";
import {
  Button,
  DialogActions,
  Divider,
  FormControl,
  Input,
  InputLabel,
} from "@mui/material";
import { IMaskInput } from "react-imask";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { registerOrder } from "../apis/RangerOnlineApi";

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        "#": /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const StripeCheckoutForm = (props) => {
  const { stripe, elements, order, onClose } = props;

  let navigate = useNavigate();

  const [values, setValues] = React.useState({
    textmask: "",
    numberformat: "1320",
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    //https://example.com/order/123/complete
    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: "http://localhost:3000/SamosaHouse/Success/0/",
      },
      redirect: "if_required",
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      let orderCopy = { ...order };
      orderCopy.paymentType = "card";
      const orderResponse = await registerOrder(orderCopy);
      navigate(`/Success/${orderResponse.orderId}/`);
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <DialogActions
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Button variant={"contained"} color="error" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button variant={"contained"} type="submit" disabled={!stripe}>
          Submit
        </Button>
      </DialogActions>
    </form>
  );
};

export default function InjectedStripeCheckoutForm(props) {
  const { order, onClose } = props;
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <StripeCheckoutForm
          stripe={stripe}
          elements={elements}
          order={order}
          onClose={onClose}
        />
      )}
    </ElementsConsumer>
  );
}
